declare type TimeRangeConditionCheck = (timeRange: TimeRange, index: number, timeRanges: TimeRanges) => boolean;

interface TimeRange {
  start: number;
  end: number;
}

export interface BufferedAmount {
  ahead: number;
  behind: number;
}

export function getBufferedAmount(videoElement: HTMLVideoElement): BufferedAmount {
  const currentTime = videoElement.currentTime;
  const bufferedRange = findIntersectingBufferedRange(videoElement);

  return {
    ahead: bufferedRange ? bufferedRange.end - currentTime : 0,
    behind: bufferedRange ? currentTime - bufferedRange.start : 0,
  };
}

function findIntersectingBufferedRange(videoElement: HTMLVideoElement): TimeRange | undefined {
  const currentTime = videoElement.currentTime;

  return findTimeRange(videoElement.buffered, (timeRange: TimeRange) => {
    return timeRange.start <= currentTime && timeRange.end >= currentTime;
  });
}

function findTimeRange(timeRanges: TimeRanges, condition: TimeRangeConditionCheck): TimeRange | undefined {
  for (let i = 0; i < timeRanges.length; i++) {
    const timeRange = {
      start: timeRanges.start(i),
      end: timeRanges.end(i),
    };
    if (condition(timeRange, i, timeRanges)) {
      return timeRange;
    }
  }

  return undefined;
}
